export default __webpack_public_path__ + "static/media/portfolio-133.7d562263.jpg";